export class AuthResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "accessToken",
            "baseName": "accessToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "expiresIn",
            "baseName": "expiresIn",
            "type": "number",
            "format": ""
        },
        {
            "name": "idToken",
            "baseName": "idToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "refreshToken",
            "baseName": "refreshToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "tokenType",
            "baseName": "tokenType",
            "type": "string",
            "format": ""
        },
        {
            "name": "challengeName",
            "baseName": "challengeName",
            "type": "string",
            "format": ""
        },
        {
            "name": "session",
            "baseName": "session",
            "type": "string",
            "format": ""
        },
        {
            "name": "challengeParameters",
            "baseName": "challengeParameters",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AuthResponse.attributeTypeMap;
    }
    constructor() {
    }
}
